import { Injectable } from '@angular/core';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NgxUiLoaderConfig } from 'ngx-ui-loader';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  public static ngxUiLoaderConfig: NgxUiLoaderConfig = {
    fgsColor: '#008393',
  };

  constructor(private ngxUiLoaderService: NgxUiLoaderService) {}

  start() {
    this.ngxUiLoaderService.start();
  }

  stop() {
    this.ngxUiLoaderService.stop();
  }
}
